import { Column, Entity, Index } from 'typeorm';
import type { EmailAddressStatus, EmailAddressStatusSource } from '../../constants/email-address-status';
import { BaseEntity } from './base.entity';

/**
 * PD-17605 — the current status of one email address in the tenant (see
 * constants/email-address-status.ts). One row per address, keyed by the
 * lower-cased address (emailAddressKey); the address is never removed, so a
 * status survives the person or record that carried it. Every change is also
 * written to `email_address_status_event`.
 */
@Index('IDX_email_address_status_email', ['email'], { unique: true })
@Entity('email_address_status')
export class EmailAddressStatusEntity extends BaseEntity {
	@Column('varchar', { name: 'email', length: 320 })
	public email!: string;

	@Column('varchar', { name: 'status', length: 16 })
	public status!: EmailAddressStatus;

	/** When the address got its current status. */
	@Column('datetime', { name: 'statusDate' })
	public statusDate!: Date;

	@Column('varchar', { name: 'source', length: 24 })
	public source!: EmailAddressStatusSource;

	/** Why: the provider's bounce detail, the verifier's result, or the reason a person gave. */
	@Column('varchar', { name: 'reason', length: 500, nullable: true })
	public reason!: string | null;

	/** The provider's bounce type for a bounce (SES `Permanent`, SendGrid `bounce`). */
	@Column('varchar', { name: 'bounceType', length: 60, nullable: true })
	public bounceType!: string | null;
}
